import { Component, OnInit, Input, ChangeDetectionStrategy, Output,EventEmitter  } from '@angular/core';
import { SharedService } from '../../../../component/shared/shared.service';
import { AppointmentService } from '../../../appointment/service/appointment.service';
import { PrescriptionService } from '../../service/prescription.service';
import { Patient} from '../../model/patient';
import { Prescription,MAppointmentAfterCall} from '../../model/prescription';
import { Appointment } from '../../../appointment/model/appointment';
import { PatientService } from '../../service/patient-service.service';
import { DialogAction, ActionMessage } from '../../../../shared/enum/dialog-action.enum';
import { DrugServiceService } from '../../../master/services/drug-service.service';
import { Drug } from '../../../master/model/drug';
@Component({
  selector: 'app-prescription',
  templateUrl: './prescription.component.html',
  styleUrls: ['./prescription.component.css'] 
})
export class PrescriptionComponent implements OnInit {
  @Input() patient : Patient ;
  @Input() appPData : any;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() visibleSave: EventEmitter<boolean> = new EventEmitter<boolean>();
  isAdd : boolean = true;
  isEdit: boolean = false;
  isErrorMessage : boolean = false;
  isDrugErrorMessage : boolean = false;
  isSuccessMessage : boolean = false;
  isDrugSuccessMessage : boolean = false;
  selectedOption : string = 'CMP';
  patientInfo : Patient;
  Aloading : boolean = false;
  message : string;
  appointments : Appointment[];
  selectedAppointment : Appointment;
  appdata : string = null;
  prescriptionData : Prescription;
  prescriptionList : Prescription[];
  searchOption : string = '';
  prescription:any[];
  isMasterAdd: boolean = false;
  masterText:string = '';
  drugsList:any[];
  files : any[] = [];
  drugStrength : string ='';
  drugNote : string = '';
  user:any;
  drugloading: boolean = false;
  afterCall:MAppointmentAfterCall = null; 
  generics: string[] = [];
  isUpload: string = "2";
  option: string ="1";
  constructor(private _sharedService: SharedService, private _usrService : PatientService,
    private _prvSrv :  PrescriptionService, private _drugSrv : DrugServiceService) {
      _sharedService.yesEmitted$.subscribe(
        text => {
            if(text.Action===DialogAction.DELETE.toString()  && text.Page === 'PRESCRIPTION') {
               this.deletePrescription(text.Data);
            } 
            if(text.Action===DialogAction.COPY.toString()  && text.Page === 'PRESCRIPTIONCOPY') {
              this.copyPrescription(text.Data);
           }  
        });
         this._usrService.text$.subscribe(data=>{
          this.appointments =  data.filter(x=> x.AppointmentIsBooked==true && x.AppointmentIsCancelled==false && x.IsComplete==0);
          if(this.appointments.length>0){
            this.selectedAppointment = this.appointments[0];
            this.appdata = this.appointments[0].AppointmentId.toString();
          } else {
            this.appdata = this.appointments[0].AppointmentId.toString();
          }
         
         
        })

        this.afterCall = new MAppointmentAfterCall(null,null,'','','','Indoor Care','','','','',[],[]);
        this.files.push({file: null,text:''})
     }



  onChange(event: EventTarget, index: number) {
    let eventObj: MSInputMethodContext = <MSInputMethodContext> event;
    let target: HTMLInputElement = <HTMLInputElement> eventObj.target;
    let files: FileList = target.files;
    this.files[index].file = files[0];
    this.files[index].text = files[0].name;
    
  }
  addClinicalNotes() {
    this.Aloading = true;;
    let data = this.appointments.filter(x=>x.AppointmentId == parseInt(this.appdata))
      for(let x of this.prescription){
        
         x.AppointmentId = this.appdata;
         
         if(data !== undefined && data.length>0) {
          x.AppointmentDay = data[0].AppointmentDay;
          x.AppointmentTime = data[0].AppointmentTime;
         } else {

         }
         
      }
    //}
    this._prvSrv.afterCall = this.afterCall;
    this._prvSrv.afterCall.Prescriptions = this.prescription;
    this._prvSrv.afterCall.AppointmentDay = data[0].AppointmentDay;
    this._prvSrv.afterCall.AppointmentTime = data[0].AppointmentTime;
    this._prvSrv.afterCall.AppointmentId = parseInt(this.appdata);
    this._prvSrv.afterCall.PatientId = this.patient.PatientId;
    if(this.files[0].text != "") {
      this._prvSrv.PrescFile = this.files;
        this._prvSrv.savePrescriptionCallData().subscribe(data=>{
          this._prvSrv.afterCall.Prescriptions[0].PrescriptionPath = data.Prescriptions[0].PrescriptionPath;
          this._prvSrv.afterCall.PrescriptionFiles = data.PrescriptionFiles;
          this._prvSrv.saveAfterCallData().subscribe(data=>{
            this.message = "Prescription saved successfully";
            this.isSuccessMessage = true;
            this.Aloading = false;
            this.hideMessage();
           // this.cancelOperation() ;
            this.GetPatientAppointment();
            setTimeout(()=>{
              this.visibleSave.emit(true);
            }, 2000)
            //this.getPrescriptions();
        },
        error=>{
          this.message = error.data;
          this.isErrorMessage = true;
          this.Aloading = false;
          this.hideMessage();
          
        });
          //this.getPrescriptions();
      },
      error=>{
        this.message = error.data;
        this.isErrorMessage = true;
        this.Aloading = false;
        this.hideMessage();
        
      });
    } else {
      this._prvSrv.saveAfterCallData().subscribe(data=>{
        this.message = "Prescription saved successfully";
        this.isSuccessMessage = true;
        this.Aloading = false;
        this.hideMessage();
       // this.cancelOperation() ;
        this.GetPatientAppointment();
        setTimeout(()=>{
          this.visibleSave.emit(true);
        }, 2000)
        //this.getPrescriptions();
    },
    error=>{
      this.message = error.data;
      this.isErrorMessage = true;
      this.Aloading = false;
      this.hideMessage();
      
    });
    }
  }

  addFiles() {
    this.files.push({text : '', file : null, reportId : null});
     
  }
  removeFiles(index : number, item : any) {
    this.files.splice(index,1);
  }

  addPrescriptionMaster() {

  }

  copyPrescriptionData(data : any) {
    
    if(this.appdata!== undefined && this.appdata!= null && this.appdata !== "null" ) {
          this.prescriptionData = data.PrescriptionList[0];
          if(parseInt(this.appdata) !== this.prescriptionData.AppointmentId) {
            this._sharedService.emitDialog(true, "Copy", ActionMessage.COPY.toString(),true,DialogAction.COPY.toString(), 'PRESCRIPTIONCOPY',this.prescriptionData );   

          } else {
            this.message = "Prescription is already exist for this date!";
            this.isSuccessMessage = false;
            this.isErrorMessage = true;
            
            this.Aloading = false;
            this.hideMessage();
          }
      
    } else {
      this.message = "Please select appointment date to be copy!";
      this.isSuccessMessage = false;
      this.isErrorMessage = true;
      
      this.Aloading = false;
      this.hideMessage();
    }
  }

  saveClinicalNotes() : void {
   
     if(this.isUpload=='2') {
        if(this.files[0].text==''){
          this.message = "Please select prescription file to upload!";
          this.isSuccessMessage = false;
          this.isErrorMessage = true;
          return;
        }
     }
     this.Aloading = true;
      this.addClinicalNotes();
    
  }

  cancelOperation() : void {
   // this.isAdd = false;
   // this.isEdit = false;
    this.prescription = [];
    this.afterCall = new MAppointmentAfterCall(null,null,'','','','Indoor Care','','','','',[],[]);
    this.setPrescriptionData();
    this.visibleChange.emit(false);
  }
  deletePrescriptionData(data : any) {
    this.prescriptionData = data.PrescriptionList[0];
    this._sharedService.emitDialog(true, "Delete", ActionMessage.DELETE.toString(),true,DialogAction.DELETE.toString(), 'PRESCRIPTION',this.prescriptionData );      
    
  }
  deletePrescription(objPresscription : Prescription) {
    this._prvSrv.deletePrescription(objPresscription).subscribe(data=>{
        this.message = "Prescription delete successfully";
        this.isSuccessMessage = true;
        this.Aloading = false;
        this.hideMessage();
        this.cancelOperation() ;
        this.getPrescriptions();
    },
    error=>{
      this.message = error.data;
      this.isErrorMessage = true;
      this.Aloading = false;
      this.hideMessage();
      
    });
  }

  copyPrescription(objPresscription : Prescription) {
   
    var data = this.appointments.filter(x=>x.AppointmentId == parseInt(this.appdata))
    debugger;
    if(data != null && data.length>0) {
      objPresscription.AppointmentDay = data[0].AppointmentDay;
      objPresscription.AppointmentTime = data[0].AppointmentTime;
      objPresscription.PrescriptionAutoId = objPresscription.AppointmentId;
      objPresscription.AppointmentId = data[0].AppointmentId;
     
    this._prvSrv.copyPrescription(objPresscription).subscribe(data=>{
        this.message = "Prescription copied successfully";
        this.isSuccessMessage = true;
        this.Aloading = false;
        this.hideMessage();
        this.cancelOperation() ;
        this.getPrescriptions();
    },
    error=>{
      this.message = error.data;
      this.isErrorMessage = true;
      this.Aloading = false;
      this.hideMessage();
      
    });
  
    }
  }  

  editClinicalData(vitalobj : Prescription[]) {
    this.isEdit = true;
    this.prescription = JSON.parse(JSON.stringify( vitalobj));
  }

  hideMessage() : void {
    setTimeout(() => {
      this.isErrorMessage  = false;
      this.isSuccessMessage  = false;   
      this.message = '';
    }, 1000);
  }

  getDrugs() : void {
    this.drugsList = [];
    this._drugSrv.getDrugs().subscribe(data=>{
        this.drugsList = data;
    },
    error=>{
    });
  }

  getGeneric(text: string, item: any) : void {
    if(text !=="" && text.length>3) {
      this.drugsList = [];
      item.genflag = false;
        this._prvSrv.getGenericName(text, item.DrugGenericName).subscribe(data=>{
          item.generics = data;
          item.genflag = true;
        },
        error=>{
        });
    } else {
      
    }
    
  }

  searchBrand(drug: string, item: any, index: any) {
    item.flag = false;
    this.drugsList = [];
    this._drugSrv.GetDrugsByGeneric(item.DrugGenericName,drug).subscribe(data=>{
      item.flag = true;
      document.getElementById('search-result'+index).className = "search-result search-result-open";
      item.drugsList = data;
    },
    error=>{
    });
  }

  onSelectDrug(item: Drug, data: any): void {
    data.DrugsName = item.DrugsName;
    data.flag = false;  
  }
  onSelectDrugGeneric(item: any, data: any): void {
    data.DrugGenericName = item.DrugGenericName;
    data.genflag = false;  
  }

  getPrescriptions() : void {
    this.Aloading = true;
    this.prescriptionList = [];
    this._prvSrv.getPrescription(this.patient.PatientId).subscribe(data=>{
      this.Aloading = false;
        this.prescriptionList = data;
        this.Aloading = false;
        this.hideMessage();
    },
    error=>{
      this.Aloading = false;
    });
  }
  setPrescriptionData() {
  // this.drugs= [];
    this.prescription = [new Prescription( this.patient.PatientId,'', '',null,'Day',null, null, null, false, false,'','','',null,null,"","")];
    //this.drugs.push({text : ''});
  }
  setData(text : any) {
      let emptyCount = 0;
    for(let i=0;i<this.prescription.length;i++) {
      if(this.prescription[i].DrugsName !== '') {
        emptyCount = emptyCount +1;
      }
      else {
          this.prescription[i].DrugsName = text.DrugsName;
          this.prescription[i].DrugStrength = text.DrugStrength;
          this.prescription[i].DrugInstruction = text.DrugInstruction;
          break;
      }
    }
    if(emptyCount==this.prescription.length)
    {
      let data = new Prescription( this.patient.PatientId,text.DrugsName, text.DrugStrength,null,'Day',null, null, null, false, false,text.DrugInstruction,'','',null)
      this.prescription.push(data);
    }
  }

  ngOnInit() {
    if(this.appPData) {
      this.appointments = this.appPData.appData;
      this.appdata = this.appPData.appId;
    }
    this.user = JSON.parse(sessionStorage.getItem("User"));
    //this.getPrescriptions();
    //this.getDrugs();
    this.setPrescriptionData();
  }
  ngOnChanges() {
    //this.getPrescriptions();
    
  }

  setMealType(type,item) {
    if(type==1) {
       if(item.DrugTime1 != 1) {
         item.DrugTime1 = 1;
       } else {
         item.DrugTime1 = 0;
       }
    }
    if(type==2) {
      if(item.DrugTime2 != 1) {
        item.DrugTime2 = 1;
      } else {
        item.DrugTime2 = 0;
      }
   }
   if(type==3) {
    if(item.DrugTime3 != 1) {
      item.DrugTime3 = 1;
    } else {
      item.DrugTime3 = 0;
    }
 }
  }

  setBeforeMeal(type, isMeal, item) {
    if(type==1) {
      item.IsBeforeMeal = false;
      item.IsAfterMeal = false;
       if(isMeal==1) {
        item.IsBeforeMeal = true;
       } else {
        item.IsAfterMeal = true;
       }
    }
    if(type==2) {
      item.Is2BeforeMeal = false;
      item.Is2AfterMeal = false;
       if(isMeal==1) {
        item.Is2BeforeMeal = true;
       } else {
        item.Is2AfterMeal = true;
       }
    }
    if(type==3) {
      item.Is3BeforeMeal = false;
      item.Is3AfterMeal = false;
       if(isMeal==1) {
        item.Is3BeforeMeal = true;
       } else {
        item.Is3AfterMeal = true;
       }
    }
  }
  
  addPrescription() {
    
    this.prescription.push(new Prescription( this.patient.PatientId,'', '',null,'Day',null, null, null, false, false,'','','',null));
  }
  removePrescription(index : number) {
    this.prescription.splice(index,1);
    if(this.prescription.length==0) {
      this.addPrescription();
    }
  }
  trackByIndex(index: number, value: number) {
    return index;
  }
  saveMaster() {
    this.drugloading = true;
    this._drugSrv.data = new Drug(null,this.masterText,this.drugStrength,this.drugNote,'','',0,0,'Oral');
    this._drugSrv.saveDrug().subscribe(data=>{
      this.drugloading = false;
      this.isDrugSuccessMessage = true;
      this.isDrugErrorMessage = false;
      this.message ="Drug added successfully";
      this.masterText = "";
      this.drugStrength = "";
      this.drugNote = "";
      setTimeout(() => {
        this.isDrugErrorMessage  = false;
        this.isDrugSuccessMessage  = false;   
        this.message = '';
        this.isMasterAdd = false;
       
        this.Aloading = false;
        this.getDrugs();
      }, 1000);
    
    },error=>{
      this.isMasterAdd = false;
      this.drugStrength = "";
      this.drugNote = "";
      this.Aloading = false;
      this.drugloading = false;
    })
  }

  GetPatientAppointment() : void {
    this.Aloading = true;
    this.appointments = [];
    this._usrService.getPatientAppointment(this.patient.PatientId).subscribe(data=>{
      this.Aloading = false;
        this.appointments = data.filter(function(app){
          return (app.AppointmentIsCancelled === false);
        });
        this.appointments =  data.filter(x=> x.AppointmentIsBooked==true && x.AppointmentIsCancelled==false && x.IsComplete==0);
        if(this.appointments.length>0){
          this.selectedAppointment = this.appointments[0];
          this.appdata = this.appointments[0].AppointmentId.toString();
        }
        this._usrService.publishText( this.appointments);
    },
    error=>{
      this.Aloading = false;
    });
  }
  
}



// WEBPACK FOOTER //
// ./src/app/section/patient/view-patient-profile/prescription/prescription.component.ts